import { FC, useEffect } from 'react';
import useNavigateTo from 'hooks/useNavigateTo';
// Redux
import { useAppSelector } from 'hooks/useStore';
import { selectBanner } from 'store/pages/pagesSelectors';
import { selectQuiz } from 'store/quiz/quizSelectors';
import { selectPreviewPageMode } from 'store/player/playerSelectors';
import IQuiz from 'models/Quiz';
// Components
import Dialog from 'components/Dialog';
import AppBar from 'components/AppBar';
import PoweredBy from 'components/PoweredBy';

type Props = {
  onClose: () => void;
}

let timeout:any = null;

const ImageDialog:FC<Props> = ({
  // Props
  onClose
}) => {
  const quiz:IQuiz | null = useAppSelector(selectQuiz);
  const banner = useAppSelector(selectBanner);
  const previewPageMode = useAppSelector(selectPreviewPageMode);

  const timeoutTime = banner.timeout ? banner.timeout * 1000 : 2000;

  const navigateTo = useNavigateTo();

  useEffect(() => {
    if (!banner.source) navigateTo('pages-handler');
    return () => {
      if ( timeout ) clearTimeout(timeout);
    }
    // eslint-disable-next-line
  }, []);

  const handleLoad = () => {
    if (previewPageMode) return;
    if ( timeout ) clearTimeout(timeout);
    timeout = setTimeout(() => {
      onClose();
      navigateTo('pages-handler')
    }, timeoutTime);
  }

  if (!banner.source) return null;
  return (
    <Dialog classes="p-4" background={quiz?.backgroundImage ? `url('${quiz.backgroundImage}') center / cover` : ''}>
      <AppBar />
      <div className="py-4 relative w-full h-full flex flex-col items-center justify-center gap-6">
        {banner.title ? (
          <h2 className="text-xl font-bold text-primary text-center">{banner.title}</h2>
        ) : null}
        <img
          className="relative z-10 shadow-primary rounded-lg"
          src={banner.source}
          onLoad={handleLoad}
          alt=""
        />
        {banner.text ? (
          <p className="text-md font-semibold text-primary text-center whitespace-pre-line">{banner.text}</p>
        ) : null}
      </div>
      <PoweredBy />
    </Dialog>
  )
}

export default ImageDialog;